import { render, staticRenderFns } from "./EprescribeSidePreview.vue?vue&type=template&id=77ab4452&scoped=true"
import script from "./EprescribeSidePreview.vue?vue&type=script&lang=js"
export * from "./EprescribeSidePreview.vue?vue&type=script&lang=js"
import style0 from "./EprescribeSidePreview.vue?vue&type=style&index=0&id=77ab4452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ab4452",
  null
  
)

export default component.exports